// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1s61m","title":"Info_title__1Qi-6","selects":"Info_selects__3Q60O","requiredAsterisk":"Info_requiredAsterisk__38VIe"};